import { render, staticRenderFns } from "./settleMentAdjust.vue?vue&type=template&id=68b4fd32"
import script from "./settleMentAdjust.vue?vue&type=script&lang=js"
export * from "./settleMentAdjust.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports